import { usePageSectionData } from '@/components/page-sections/page-section-context';
import { EmptyState } from '@/components/shared/empty-state';
import { type CaseResultWidgetProps, CaseResultWidgetVariant } from './definition';
import { CardsVariant } from './variants/cards';
import { GridVariant } from './variants/grid';
import { ListVariant } from './variants/list';

export function CaseResultWidgetSection() {
  const { props, variant = CaseResultWidgetVariant.GRID } =
    usePageSectionData<Partial<CaseResultWidgetProps>>();
  const { title, caseResults: rawCaseResults } = props;

  const caseResults = Array.isArray(rawCaseResults) ? rawCaseResults : [];

  const hasCaseResults = caseResults.length > 0;

  if (!hasCaseResults) {
    return (
      <EmptyState message="No case results available. Add case results to display them here." />
    );
  }

  switch (variant) {
    case CaseResultWidgetVariant.LIST:
      return <ListVariant title={title} caseResults={caseResults} />;
    case CaseResultWidgetVariant.CARDS:
      return <CardsVariant title={title} caseResults={caseResults} />;
    default:
      return <GridVariant title={title} caseResults={caseResults} />;
  }
}
